var _a;
import { TrilogyThemeContext } from '../../context/providerTheme';
import { useContext } from 'react';
/**
 * Trilogy color
 */
export var TrilogyColor;
(function (TrilogyColor) {
    TrilogyColor["BACKGROUND"] = "WHITE";
    TrilogyColor["MAIN"] = "MAIN";
    TrilogyColor["MAIN_FADE"] = "MAIN_FADE";
    TrilogyColor["ACCENT"] = "ACCENT";
    TrilogyColor["FONT"] = "FONT";
    TrilogyColor["SUCCESS"] = "SUCCESS";
    TrilogyColor["SUCCESS_FADE"] = "SUCCESS_FADE";
    TrilogyColor["INFO"] = "INFO";
    TrilogyColor["INFO_FADE"] = "INFO_FADE";
    TrilogyColor["WARNING"] = "WARNING";
    TrilogyColor["WARNING_FADE"] = "WARNING_FADE";
    TrilogyColor["ERROR"] = "ERROR";
    TrilogyColor["ERROR_FADE"] = "ERROR_FADE";
    TrilogyColor["DISABLED"] = "DISABLED";
    TrilogyColor["DISABLED_FADE"] = "DISABLED_FADE";
    TrilogyColor["NEUTRAL"] = "NEUTRAL";
    TrilogyColor["NEUTRAL_FADE"] = "NEUTRAL_FADE";
})(TrilogyColor || (TrilogyColor = {}));
/**
 * Trilogy color values
 */
export var colors = (_a = {},
    _a[TrilogyColor.BACKGROUND] = ['#fff', 'white', 'main'],
    _a[TrilogyColor.MAIN] = ['#3d5d7e', 'main', 'white'],
    _a[TrilogyColor.MAIN_FADE] = ['#BBC6CD', 'main-fade', 'white'],
    _a[TrilogyColor.ACCENT] = ['#da641b', 'accent', 'white'],
    _a[TrilogyColor.FONT] = ['#3d5d7e', 'main', 'white'],
    _a[TrilogyColor.SUCCESS] = ['#007B52', 'success', 'white'],
    _a[TrilogyColor.SUCCESS_FADE] = ['#cae8ca', 'success-fade', 'white'],
    _a[TrilogyColor.INFO] = ['#1A688A', 'info', 'white'],
    _a[TrilogyColor.INFO_FADE] = ['#c8dbec', 'info-fade', 'white'],
    _a[TrilogyColor.WARNING] = ['#FFBB33', 'warning', 'white'],
    _a[TrilogyColor.WARNING_FADE] = ['#ecdbc6', 'warning-fade', 'white'],
    _a[TrilogyColor.ERROR] = ['#D42D02', 'error', 'white'],
    _a[TrilogyColor.ERROR_FADE] = ['#eecccc', 'error-fade', 'white'],
    _a[TrilogyColor.DISABLED] = ['#646464', 'disabled', 'white'],
    _a[TrilogyColor.DISABLED_FADE] = ['#D1D1D1', 'disabled-fade', 'white'],
    _a[TrilogyColor.NEUTRAL] = ['#707070', 'grey', 'white'],
    _a[TrilogyColor.NEUTRAL_FADE] = ['#F4F4F4', 'grey-fade', 'white'],
    _a);
/**
 * Returns color's className depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Color className value
 */
export var getColorClassName = function (trilogyColor) {
    var color = colors[trilogyColor];
    return color[1];
};
/**
 * Returns color button's className depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Variant Button value
 */
export var getButtonVariantClassName = function (trilogyColor) {
    switch (trilogyColor) {
        case 'CONVERSION':
            return 'conversion';
        case 'PRIMARY':
            return 'primary';
        case 'SECONDARY':
            return 'secondary';
        case 'GHOST':
            return 'ghost';
        case 'SUCCESS':
            return 'success';
        case 'INFO':
            return 'info';
        case 'WARNING':
            return 'warning';
        case 'ERROR':
            return 'error';
        case 'DISABLED':
            return 'disabled';
        default:
            return 'primary';
    }
};
export var getButtonColorStyle = function (buttonVariant) {
    switch (buttonVariant) {
        case 'ACCENT':
            return TrilogyColor.ACCENT;
        case 'PRIMARY':
            return TrilogyColor.MAIN;
        case 'SECONDARY':
            return TrilogyColor.MAIN_FADE;
        case 'GHOST':
            return TrilogyColor.BACKGROUND;
        default:
            return TrilogyColor.MAIN;
    }
};
/**
 * Returns color's style depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @param index {number} - Index of color ( 1 for BG )
 * @returns {string} - Color style value
 */
export var getColorStyle = function (trilogyColor) {
    if (typeof navigator !== 'undefined' && navigator.userAgent === undefined) {
        var theme = useContext(TrilogyThemeContext).theme;
        var colorsStyle = (theme === null || theme === void 0 ? void 0 : theme.colors) || colors;
        var colorArray = colorsStyle[trilogyColor] || colorsStyle.default;
        if (trilogyColor === 'transparent')
            return 'transparent';
        if (!trilogyColor || !colors[trilogyColor]) {
            return colorsStyle.default;
        }
        return colorArray[0];
    }
    else {
        if (trilogyColor === 'transparent')
            return 'transparent';
        return colors[trilogyColor][0] || colors[TrilogyColor.MAIN][0];
    }
};
function hexToRgb(hex) {
    if (hex.charAt(0) === '#') {
        hex = hex.slice(1);
    }
    if (hex.length !== 6) {
        throw new Error('Wrong format (hexadecimal)');
    }
    // Conversion
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return { r: r, g: g, b: b };
}
function rgbToHex(r, g, b) {
    var toHex = function (n) {
        var hex = n.toString(16);
        return hex.length === 1 ? "0".concat(hex) : hex;
    };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
}
export function grayscale(hex) {
    var _a = hexToRgb(hex), r = _a.r, g = _a.g, b = _a.b;
    // Formule de luminosité relative
    var gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);
    // Retourner la couleur en niveaux de gris
    return rgbToHex(gray, gray, gray);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9vYmplY3RzL2ZhY2V0cy9Db2xvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxNQUFNLHlCQUF5QixDQUFBO0FBQzdELE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxPQUFPLENBQUE7QUFFbEM7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxZQWtCWDtBQWxCRCxXQUFZLFlBQVk7SUFDdEIsb0NBQW9CLENBQUE7SUFDcEIsNkJBQWEsQ0FBQTtJQUNiLHVDQUF1QixDQUFBO0lBQ3ZCLGlDQUFpQixDQUFBO0lBQ2pCLDZCQUFhLENBQUE7SUFDYixtQ0FBbUIsQ0FBQTtJQUNuQiw2Q0FBNkIsQ0FBQTtJQUM3Qiw2QkFBYSxDQUFBO0lBQ2IsdUNBQXVCLENBQUE7SUFDdkIsbUNBQW1CLENBQUE7SUFDbkIsNkNBQTZCLENBQUE7SUFDN0IsK0JBQWUsQ0FBQTtJQUNmLHlDQUF5QixDQUFBO0lBQ3pCLHFDQUFxQixDQUFBO0lBQ3JCLCtDQUErQixDQUFBO0lBQy9CLG1DQUFtQixDQUFBO0lBQ25CLDZDQUE2QixDQUFBO0FBQy9CLENBQUMsRUFsQlcsWUFBWSxLQUFaLFlBQVksUUFrQnZCO0FBSUQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxNQUFNO0lBQ2pCLEdBQUMsWUFBWSxDQUFDLFVBQVUsSUFBRyxDQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUUsTUFBTSxDQUFDO0lBQ3BELEdBQUMsWUFBWSxDQUFDLElBQUksSUFBRyxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsT0FBTyxDQUFDO0lBQ2pELEdBQUMsWUFBWSxDQUFDLFNBQVMsSUFBRyxDQUFDLFNBQVMsRUFBRSxXQUFXLEVBQUUsT0FBTyxDQUFDO0lBQzNELEdBQUMsWUFBWSxDQUFDLE1BQU0sSUFBRyxDQUFDLFNBQVMsRUFBRSxRQUFRLEVBQUUsT0FBTyxDQUFDO0lBRXJELEdBQUMsWUFBWSxDQUFDLElBQUksSUFBRyxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsT0FBTyxDQUFDO0lBRWpELEdBQUMsWUFBWSxDQUFDLE9BQU8sSUFBRyxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsT0FBTyxDQUFDO0lBQ3ZELEdBQUMsWUFBWSxDQUFDLFlBQVksSUFBRyxDQUFDLFNBQVMsRUFBRSxjQUFjLEVBQUUsT0FBTyxDQUFDO0lBRWpFLEdBQUMsWUFBWSxDQUFDLElBQUksSUFBRyxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsT0FBTyxDQUFDO0lBQ2pELEdBQUMsWUFBWSxDQUFDLFNBQVMsSUFBRyxDQUFDLFNBQVMsRUFBRSxXQUFXLEVBQUUsT0FBTyxDQUFDO0lBRTNELEdBQUMsWUFBWSxDQUFDLE9BQU8sSUFBRyxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsT0FBTyxDQUFDO0lBQ3ZELEdBQUMsWUFBWSxDQUFDLFlBQVksSUFBRyxDQUFDLFNBQVMsRUFBRSxjQUFjLEVBQUUsT0FBTyxDQUFDO0lBRWpFLEdBQUMsWUFBWSxDQUFDLEtBQUssSUFBRyxDQUFDLFNBQVMsRUFBRSxPQUFPLEVBQUUsT0FBTyxDQUFDO0lBQ25ELEdBQUMsWUFBWSxDQUFDLFVBQVUsSUFBRyxDQUFDLFNBQVMsRUFBRSxZQUFZLEVBQUUsT0FBTyxDQUFDO0lBRTdELEdBQUMsWUFBWSxDQUFDLFFBQVEsSUFBRyxDQUFDLFNBQVMsRUFBRSxVQUFVLEVBQUUsT0FBTyxDQUFDO0lBQ3pELEdBQUMsWUFBWSxDQUFDLGFBQWEsSUFBRyxDQUFDLFNBQVMsRUFBRSxlQUFlLEVBQUUsT0FBTyxDQUFDO0lBRW5FLEdBQUMsWUFBWSxDQUFDLE9BQU8sSUFBRyxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsT0FBTyxDQUFDO0lBQ3BELEdBQUMsWUFBWSxDQUFDLFlBQVksSUFBRyxDQUFDLFNBQVMsRUFBRSxXQUFXLEVBQUUsT0FBTyxDQUFDO09BQy9ELENBQUE7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFBQyxZQUErQztJQUMvRSxJQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7SUFDbEMsT0FBTyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDakIsQ0FBQyxDQUFBO0FBRUQ7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLHlCQUF5QixHQUFHLFVBQUMsWUFBcUI7SUFDN0QsUUFBUSxZQUFZLEVBQUU7UUFDcEIsS0FBSyxZQUFZO1lBQ2YsT0FBTyxZQUFZLENBQUE7UUFDckIsS0FBSyxTQUFTO1lBQ1osT0FBTyxTQUFTLENBQUE7UUFDbEIsS0FBSyxXQUFXO1lBQ2QsT0FBTyxXQUFXLENBQUE7UUFDcEIsS0FBSyxPQUFPO1lBQ1YsT0FBTyxPQUFPLENBQUE7UUFDaEIsS0FBSyxTQUFTO1lBQ1osT0FBTyxTQUFTLENBQUE7UUFDbEIsS0FBSyxNQUFNO1lBQ1QsT0FBTyxNQUFNLENBQUE7UUFDZixLQUFLLFNBQVM7WUFDWixPQUFPLFNBQVMsQ0FBQTtRQUNsQixLQUFLLE9BQU87WUFDVixPQUFPLE9BQU8sQ0FBQTtRQUNoQixLQUFLLFVBQVU7WUFDYixPQUFPLFVBQVUsQ0FBQTtRQUNuQjtZQUNFLE9BQU8sU0FBUyxDQUFBO0tBQ25CO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLElBQU0sbUJBQW1CLEdBQUcsVUFBQyxhQUFzQjtJQUN4RCxRQUFRLGFBQWEsRUFBRTtRQUNyQixLQUFLLFFBQVE7WUFDWCxPQUFPLFlBQVksQ0FBQyxNQUFNLENBQUE7UUFDNUIsS0FBSyxTQUFTO1lBQ1osT0FBTyxZQUFZLENBQUMsSUFBSSxDQUFBO1FBQzFCLEtBQUssV0FBVztZQUNkLE9BQU8sWUFBWSxDQUFDLFNBQVMsQ0FBQTtRQUMvQixLQUFLLE9BQU87WUFDVixPQUFPLFlBQVksQ0FBQyxVQUFVLENBQUE7UUFDaEM7WUFDRSxPQUFPLFlBQVksQ0FBQyxJQUFJLENBQUE7S0FDM0I7QUFDSCxDQUFDLENBQUE7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxVQUFDLFlBQStEO0lBQzNGLElBQUksT0FBTyxTQUFTLEtBQUssV0FBVyxJQUFJLFNBQVMsQ0FBQyxTQUFTLEtBQUssU0FBUyxFQUFFO1FBQ2pFLElBQUEsS0FBSyxHQUFLLFVBQVUsQ0FBQyxtQkFBbUIsQ0FBQyxNQUFwQyxDQUFvQztRQUNqRCxJQUFNLFdBQVcsR0FBRyxDQUFBLEtBQUssYUFBTCxLQUFLLHVCQUFMLEtBQUssQ0FBRSxNQUFNLEtBQUksTUFBTSxDQUFBO1FBRTNDLElBQU0sVUFBVSxHQUFHLFdBQVcsQ0FBQyxZQUFZLENBQUMsSUFBSSxXQUFXLENBQUMsT0FBTyxDQUFBO1FBQ25FLElBQUksWUFBWSxLQUFLLGFBQWE7WUFBRSxPQUFPLGFBQWEsQ0FBQTtRQUV4RCxJQUFJLENBQUMsWUFBWSxJQUFJLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxFQUFFO1lBQzFDLE9BQU8sV0FBVyxDQUFDLE9BQU8sQ0FBQTtTQUMzQjtRQUNELE9BQU8sVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFBO0tBQ3JCO1NBQU07UUFDTCxJQUFJLFlBQVksS0FBSyxhQUFhO1lBQUUsT0FBTyxhQUFhLENBQUE7UUFDeEQsT0FBTyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksTUFBTSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtLQUMvRDtBQUNILENBQUMsQ0FBQTtBQUVELFNBQVMsUUFBUSxDQUFDLEdBQVc7SUFDM0IsSUFBSSxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLEdBQUcsRUFBRTtRQUN6QixHQUFHLEdBQUcsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQTtLQUNuQjtJQUVELElBQUksR0FBRyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDcEIsTUFBTSxJQUFJLEtBQUssQ0FBQyw0QkFBNEIsQ0FBQyxDQUFBO0tBQzlDO0lBQ0QsYUFBYTtJQUNiLElBQU0sQ0FBQyxHQUFHLFFBQVEsQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQTtJQUMzQyxJQUFNLENBQUMsR0FBRyxRQUFRLENBQUMsR0FBRyxDQUFDLFNBQVMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFDM0MsSUFBTSxDQUFDLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxTQUFTLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBRTNDLE9BQU8sRUFBRSxDQUFDLEdBQUEsRUFBRSxDQUFDLEdBQUEsRUFBRSxDQUFDLEdBQUEsRUFBRSxDQUFBO0FBQ3BCLENBQUM7QUFFRCxTQUFTLFFBQVEsQ0FBQyxDQUFTLEVBQUUsQ0FBUyxFQUFFLENBQVM7SUFDL0MsSUFBTSxLQUFLLEdBQUcsVUFBQyxDQUFTO1FBQ3RCLElBQU0sR0FBRyxHQUFHLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUE7UUFDMUIsT0FBTyxHQUFHLENBQUMsTUFBTSxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBSSxHQUFHLENBQUUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFBO0lBQzNDLENBQUMsQ0FBQTtJQUNELE9BQU8sV0FBSSxLQUFLLENBQUMsQ0FBQyxDQUFDLFNBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyxTQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBRSxDQUFBO0FBQzdDLENBQUM7QUFFRCxNQUFNLFVBQVUsU0FBUyxDQUFDLEdBQVc7SUFDN0IsSUFBQSxLQUFjLFFBQVEsQ0FBQyxHQUFHLENBQUMsRUFBekIsQ0FBQyxPQUFBLEVBQUUsQ0FBQyxPQUFBLEVBQUUsQ0FBQyxPQUFrQixDQUFBO0lBRWpDLGlDQUFpQztJQUNqQyxJQUFNLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssR0FBRyxDQUFDLEdBQUcsS0FBSyxHQUFHLENBQUMsR0FBRyxLQUFLLEdBQUcsQ0FBQyxDQUFDLENBQUE7SUFFMUQsMENBQTBDO0lBQzFDLE9BQU8sUUFBUSxDQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUE7QUFDbkMsQ0FBQyJ9